import script from "./Challenges.vue?vue&type=script&setup=true&lang=js"
export * from "./Challenges.vue?vue&type=script&setup=true&lang=js"

import "./Challenges.vue?vue&type=style&index=0&id=13b17fc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13b17fc8"]])

export default __exports__